import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
/**
 * Created by h3 on 2018-01-17.
 */
import {
    INearWinReelDividerConfig,
    NearWinReelDivider
} from "@nolimitcity/slot-game/bin/game/reeldivider/NearWinReelDivider";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite, TimelineMax, TweenLite} from "gsap";
import {TeslaSoundConfig} from "../TeslaSoundConfig";

export class TeslaNearWinReelDivider extends NearWinReelDivider {
    private _isPlayingSound:boolean = false;
    private _nearWinDividersContainer:PIXI.Container;
    private _teslaNearWinLayer:ScalableLayer;

    constructor(config:INearWinReelDividerConfig) {
        super(config);
        this._teslaNearWinLayer = StageManager.getLayer(config.layer);
    }


    protected initAnimations():void {
        super.initAnimations();
        this._nearWinDividersContainer = new PIXI.Container();
        for(let divider of this._nearWinDividers) {
            if(divider != null) {
                this._nearWinDividersContainer.addChild(divider);
            }
        }
        this._teslaNearWinLayer.addChild(this._nearWinDividersContainer);
    }

    protected addEventListeners():void {
        super.addEventListeners();

        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, (event:GameEvent) => this.allReelsStopped(event.params[0]));
    }

    protected getDividerAnimation(divider:TimelineSprite):Timeline {
        const tl:TimelineLite = new TimelineLite();

        tl.add([
            new TweenLite(divider, 0.1, {alpha : 1}),
            divider.getAnimation([0, 8])
        ], 0);
        tl.add(this.getLoopableFrames(divider));
        tl.add(divider.getAnimation([24, 29]));
        tl.add(new TweenLite(divider, 0.1, {alpha : 0}));

        return tl;
    }

    protected onResize(resizeData:IResizeData):void {
        this._nearWinDividersContainer.position.set(GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y);
    }


    protected playNearWinSound(reelId:number):void {

        if(!this._isPlayingSound) {
            this.playSound();
        }
    }

    private getLoopableFrames(divider:TimelineSprite):TimelineMax {
        let repeats:number = 3;
        let index = this._nearWinDividers.indexOf(divider);
        switch(index) {
            case 2:
                repeats = 1;
                break;
            case 3:
                repeats = 2;
                break;
            case 4:
                repeats = 3;
                break;
        }

        const tl:TimelineMax = new TimelineMax({repeat : repeats});
        tl.add(divider.getAnimation([9, 23]));
        return tl;
    }

    private playSound() {
        SlotGame.sound.playEffect(TeslaSoundConfig.instance.REEL_NEAR_WIN);
        this._isPlayingSound = true;
    }

    private allReelsStopped(any:any) {
        SlotGame.sound.stopEffect(TeslaSoundConfig.instance.REEL_NEAR_WIN);
        this._isPlayingSound = false;
    }
}